import { Line } from "react-chartjs-2";
import type { SessionDetail } from "../../../types";
import { useTheme, chartColors } from "../../../theme";

interface Props {
  details: SessionDetail[];
}

export default function ScoresTrendChart({ details }: Props) {
  useTheme(); // re-render on theme change so the palette below is re-resolved
  const c = chartColors();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { labels: { color: c.legend, boxWidth: 12, font: { size: 12 } } } },
    scales: {
      x: { grid: { color: c.grid }, ticks: { color: c.ticks, font: { size: 11 } } },
      y: { grid: { color: c.grid }, ticks: { color: c.ticks, font: { size: 11 } }, min: 0, max: 10 },
    },
  } as const;

  const labels = details.map((d) => `#${d.session.id}`);
  const data = {
    labels,
    datasets: [
      {
        label: "Fluency",
        data: details.map((d) => d.metrics?.fluency_score ?? 0),
        borderColor: c.success,
        backgroundColor: `${c.success}14`,
        tension: 0.35,
        borderWidth: 2,
        pointBackgroundColor: c.success,
        pointBorderColor: c.surface,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
      {
        label: "Complexity",
        data: details.map((d) => d.metrics?.complexity_score ?? 0),
        borderColor: c.terracotta,
        backgroundColor: `${c.terracotta}14`,
        tension: 0.35,
        borderWidth: 2,
        pointBackgroundColor: c.terracotta,
        pointBorderColor: c.surface,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };
  return (
    <div className="h-[200px]">
      <Line data={data} options={options} />
    </div>
  );
}
